<section>
    <div class="custom-card">
        <form [formGroup]="accountRecover" id="recoveryform">
            <div>
                <label for="email">Enter Your Email to Recover Your Account:</label>&nbsp;
                <input type="email" placeholder="Email" formControlName="userEmail" class="textField">
            </div>
            <a href="landing">
                <button type="submit" id="submitbutton">SUBMIT</button>
            </a>
        </form>
    </div>
</section>
